import { useState, useCallback } from "react";

// toggles between table and histogram views
const useHistogramToggle = (initialView = "table") => {
  const [activeView, setActiveView] = useState(initialView);

  const isHistogramView = activeView === "histogram";

  const toggleView = useCallback(() => {
    setActiveView(prev => (prev === "table" ? "histogram" : "table"));
  }, []);

  const resetView = useCallback(() => {
    setActiveView(initialView);
  }, [initialView]);

  return { activeView, isHistogramView, toggleView, resetView };
};

export default useHistogramToggle;
